import axios from 'axios';

export default {
  state: {
    list: [],
  },
  mutations: {
    setTags(state, tags) {
      state.list = tags;
    },
    addTags(state, tags) {
      for (const tag of tags) {
        const foundTag = state.list.find((t) => t.value === tag.value);
        if (!foundTag) {
          state.list.unshift(tag);
        }
      }
    },
  },
  getters: {
    getTagsList: (state) => {
      return state.list;
    },
  },
  actions: {
    getTags(context) {
      return axios.get(`/api/v2/tags`).then((response) => {
        context.commit('setTags', response.data.tags);
      });
    },
  },
};
